import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

import Modal from 'components/Modals/presets/BasicModal';

export const MissingBillingDetailsDialog = (props: any) => {
  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      heading={t('Missing Billing Details')}
      buttonText={t('Add Payment Method')}
      actionBtnColor={'blue'}
    >
      <div className="pb-2">
        <Typography>
          {t(
            'To upgrade to a paid plan, a default payment method must be added first.'
          )}
        </Typography>
      </div>
    </Modal>
  );
};
